module.exports = __webpack_public_path__ + "static/media/logo.3db7c1ad.png";